import React from 'react'
import { useDispatch } from 'react-redux'
import { useStyles } from '../UserManagement/UserProfileStyles'
import { Box, Button, Divider } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { DeleteITAdminStateData, getITAdminStateData } from '../../actions/api/fetchITAdmin'

export default function DeleteStateDialog({ params, user, open, onClose, data, openSnackBar }) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleSubmit = async () => {
    const deleteParams = {
      id: params.id,
    }

    await dispatch(DeleteITAdminStateData({ payload: deleteParams }))
    await dispatch(getITAdminStateData())
    onClose(true)
    await updateDataTable()
  }

  const updateDataTable = () => {
    dispatch(getITAdminStateData())
    openSnackBar()
  }

  return (
    <>
      <Box className={`${classes.mt} , ${classes.mb}`}>
        <Dialog
          fullWidth
          maxWidth="sm"
          id="hello"
          classes={{ paper: classes.dialogHeight }}
          open={open}
          onClose={onClose}
        >
          <DialogTitle className={classes.dialogTitle}>Delete State</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText className={classes.dialogContent}>
              Are you sure you want to delete this State?
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.btn} ${classes.buttonMargin}`}
              onClick={(event) => handleSubmit()}
              endIcon={<CheckIcon />}
            >
              Yes
            </Button>
            <Button onClick={onClose} variant="outlined" className={classes.buttonMargin} endIcon={<ClearIcon />}>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  )
}
